// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Util from './lib/util';


import 'bootstrap';
import "./main.scss";
import $ from "jquery";
import "vue-lazyload"
import util from "./lib/util";

Vue.config.productionTip = true;
// Vue.config.debug = true;
Vue.prototype.$loading = true;




(function(){
    if ( typeof window.vueCfg == 'undefined'){
        return;
    }
    let components = {};
    let module = require(`./modules/${window.vueCfg.module}`).default;
    //let md = module.default;
    components[window.vueModule] = module;

    util.globalEvents();

    var app = new Vue({
        el: '#vueRender',
        components : components,
        template : `
    <${window.vueModule} />
`
    });

})();






// WEBPACK FOOTER //
// ./src/main.js